import React from 'react';
import _ from 'lodash';
import Griddle from 'griddle-react';
import {fromJS, Map} from 'immutable';
import {PermissionRequired, TableSearch} from '../../components';
import {search} from '../../components/TableSearch/TableSearch';
import {FuelRequestsAction} from '../../actions';
import {Activities} from '../../constants';
import {FuelRequestsStore} from '../../stores';

export default React.createClass({
  propTypes: {
    fuelRequests:  React.PropTypes.object,
    loadingStatus: React.PropTypes.bool
  },

  getDefaultProps: function () {
    return {
      fuelRequests:  Map(),
      loadingStatus: false
    }
  },

  getInitialState() {
    return {
      fuelRequests: this.props.fuelRequests
    }
  },

  shouldComponentUpdate(nextProps, nextState) {
    return !_.isEqual(nextProps.fuelRequests, this.props.fuelRequests)
      || !_.isEqual(nextState.fuelRequests, this.state.fuelRequests)
      || this.props.loadingStatus !== nextProps.loadingStatus;
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.searchParams.size > 0) {
      let filteredFuelRequests = search(nextProps.fuelRequests.toJS(), nextProps.searchParams.toJS());
      this.setState({fuelRequests: fromJS(filteredFuelRequests)});
    } else {
      this.setState({fuelRequests: nextProps.fuelRequests})
    }
  },

  componentWillUnmount() {
    FuelRequestsStore.setState({ search: Map() });
  },

  render() {
    return (
      <PermissionRequired requiredRoles={Activities.READ_FUEL_REQUESTS} user={this.props.user}>
        <TableSearch
          columnMetadata={this.props.columnMetadata}
          onSearch={this.handleSearch}
        />
        <Griddle
          initialSort="createdAt"
          initialSortAscending={false}
          results={this.getRequests()}
          tableClassName="table middle-td"
          resultsPerPage={20}
          filterPlaceholderText="Search"
          columnMetadata={this.props.columnMetadata}
          columns={this.props.columnNames}
        />
      </PermissionRequired>
    )
  },

  handleSearch(e) {
    let {name, value} = e.target;
    FuelRequestsAction.search(name, value);
  },

  getRequests() {
    return _.map(this.state.fuelRequests.toJS(), (a) => {
      return a;
    });
  }
});
